import {
  createBrowserLogger,
  type BaseLogContext,
} from '@onelab/logger/browser';

interface AiLogContext extends BaseLogContext {
  [key: string]: unknown;
}

// Browser logger used here because packages/ai is isomorphic (browser + server).
export const logger = createBrowserLogger<AiLogContext>({ service: 'ai' });
